var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container-chart",staticClass:"chart-wrap relative"},[_c('highcharts',{ref:"gaugeChart",staticClass:"chart-component",attrs:{"options":_vm.options}}),(_vm.$slots.default)?_c('div',{staticClass:"center-absolute"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }